// extracted by mini-css-extract-plugin
export default {"tableScreener":"TableScreener_tableScreener__5CAwP","resizer":"TableScreener_resizer__-OQvW","resizing":"TableScreener_resizing__9QOH4","resizable":"TableScreener_resizable__30XNc"};